/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AppRouter, TitleContext, TitleElement, TitleManager } from '@gh/common-shared';
import { ContextableComponent } from '../../routing';

export class AbstractPageHeaderComponent implements OnDestroy, OnChanges {
  @Input() parentRoute: string;
  @Input() hasAlternateBackFunction: boolean;

  @Output() onBackClick?: EventEmitter<any> = new EventEmitter<any>();

  private _titleContext?: TitleContext;
  private _titleElement?: TitleElement;

  constructor(public router: AppRouter,
              private titleManager: TitleManager,
              public contextable?: ContextableComponent) {

  }

  ngOnDestroy(): void {
    if (this._titleElement) {
      this._titleElement.destroy();
    }
    if (this._titleContext) {
      this._titleContext.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.buildTitle) {
      const title = this.buildTitle();
      if (title) {
        if (this._titleElement) {
          this._titleElement.setText(title);
        } else {
          this._titleContext = this.titleManager.newContext();
          this._titleElement = this.titleManager.newElement(title);
        }
      }
    }
  }

  goBack(): void {
    if (this.hasAlternateBackFunction && this.onBackClick && this.onBackClick.emit) {
      this.onBackClick.emit();
    } else if (this.parentRoute) {
      this.router.navigateByUrl(this.parentRoute);
    } else if (this.contextable) {
      this.contextable.cancel();
    } else {
      this.router.navigateBack();
    }
  }

  protected buildTitle?(): Maybe<string>;
}
